// WebSocket Service - Manages real-time connections using Laravel Echo
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Make Pusher available globally for Laravel Echo
window.Pusher = Pusher;

let echoInstance = null;

export const initializeWebSocket = (token) => {
  if (echoInstance) {
    return echoInstance;
  }

  // Get backend URL from environment
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://dactrha-staging.novech-sy.com/api';
  const wsHost = new URL(backendUrl).hostname;

  echoInstance = new Echo({
    broadcaster: 'pusher',
    key: process.env.REACT_APP_PUSHER_KEY || 'dactrha-key',
    cluster: process.env.REACT_APP_PUSHER_CLUSTER || 'mt1',
    wsHost: wsHost,
    wsPort: 6001,
    wssPort: 6001,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: `${backendUrl}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    },
  });

  return echoInstance;
};

export const getEchoInstance = () => echoInstance;

export const disconnectWebSocket = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
};

// Subscribe to a conversation channel for real-time messages
export const subscribeToConversation = (conversationId, callbacks) => {
  if (!echoInstance) {
    console.warn('WebSocket not initialized');
    return null;
  }

  const channel = echoInstance.private(`conversation.${conversationId}`);

  if (callbacks.onMessage) {
    channel.listen('.message.new', callbacks.onMessage);
  }

  if (callbacks.onMessageRead) {
    channel.listen('.message.read', callbacks.onMessageRead);
  }

  return channel;
};

// Unsubscribe from a conversation channel
export const unsubscribeFromConversation = (conversationId) => {
  if (echoInstance) {
    echoInstance.leave(`conversation.${conversationId}`);
  }
};

// Subscribe to user channel for calls and private notifications
export const subscribeToUserChannel = (userId, callbacks) => {
  if (!echoInstance) {
    console.warn('WebSocket not initialized');
    return null;
  }

  const channel = echoInstance.private(`user.${userId}`);

  if (callbacks.onIncomingCall) {
    channel.listen('.call.incoming', callbacks.onIncomingCall);
  }

  if (callbacks.onCallSignal) {
    channel.listen('.call.signal', callbacks.onCallSignal);
  }

  return channel;
};

export const unsubscribeFromUserChannel = (userId) => {
  if (echoInstance) {
    echoInstance.leave(`user.${userId}`);
  }
};

export default {
  initializeWebSocket,
  getEchoInstance,
  disconnectWebSocket,
  subscribeToConversation,
  unsubscribeFromConversation,
  subscribeToUserChannel,
  unsubscribeFromUserChannel,
};
